import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	menuItem: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		minHeight: '32px',
		alignItems: 'flex-start',
		gap: token('space.075'),
		borderRadius: token('radius.medium'),
		backgroundColor: token('color.background.neutral.subtle'),
	},
	menuItemDisabled: {
		cursor: 'not-allowed',
		color: token('color.text.disabled'),
		opacity: token('opacity.disabled'),
	},
	menuItemIcon: {
		display: 'flex',
		width: '100%',
		height: '24px',
		alignItems: 'center',
		justifyContent: 'start',
		gap: token('space.075'),
	},
	menuItemLabel: {
		display: 'block',
		width: '100%',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
		overflow: 'hidden',
	},
	sitePickerContainer: {
		width: '100%',
	},
});

interface SelectorMenuItemProps {
	label?: string;
	icon?: React.ReactNode;
	selectComponent: JSX.Element;
	isEnabled?: boolean;
	testId?: string;
}

export const SelectorMenuItem = ({
	label,
	icon,
	selectComponent,
	isEnabled = true,
	testId,
}: SelectorMenuItemProps): React.JSX.Element => {
	const iconElement =
		typeof icon === 'string'
			? ((<Text color="color.text.subtle">{icon}</Text>) as React.ReactNode)
			: icon;

	return (
		<Box
			xcss={cx(styles.menuItem, !isEnabled && styles.menuItemDisabled)}
			testId={testId || 'selector-menu-item-container'}
		>
			{(icon != null || label != null) && (
				<Box xcss={styles.menuItemIcon}>
					{icon != null && iconElement}
					{label != null && (
						<Box xcss={styles.menuItemLabel}>
							<Text color="color.text.subtle" data-test-id="selector-menu-item-label">
								{label}
							</Text>
						</Box>
					)}
				</Box>
			)}
			<Box xcss={styles.sitePickerContainer}>{selectComponent}</Box>
		</Box>
	);
};
